<template>
	<div>
		<a-spin :spinning="loading">
			<div class="ft20 cl-main ftw600">预约看板</div>

			<div class="mt20 ">
				<a-radio-group v-model="search.mendian_id" button-style="solid" @change="changeMendian">
					<a-radio-button :value="item.mendian_id" v-for="(item, index) in mendians" :key="index">
						{{ item.name }}
					</a-radio-button>
				</a-radio-group>
			</div>

			<div class="mt20">
				<div class=" pd30 bg-w" style="min-height: 800px;">
					<div class="flex alcenter">
						<a-button type="primary" icon="plus" @click="addAppointmentAct()">新增预约</a-button>

						<div class="ml30 flex wrap">
							<div class="flex alcenter mr30" v-for="(item, index) in settings">
								<div class="setting-item" :style="{ background: item.mainColor }"></div>
								<div class="ml8 ft14 ftw600 cl-info">{{ item.status_means }}</div>
							</div>
						</div>
					</div>

					<div class="mt30">
						<div class="kanban-table-header">
							<div class="flex alcenter">
								<div style="width: 100%" class="kanban-table-header-right">
									<div class="flex alcenter space" style="height: 100%;">
										<div class="last-week-button" @click="getUpWeek()">
											<div class="flex alcenter center">
												<i class="iconfont iconlast ft12 cl-info" />
												<div class="ml2">上一周</div>
											</div>
										</div>

										<div style="width: 100%;" class="flex alcenter">
											<template v-for="(item, index) in getDays">
												<div class="this-week-item flex alcenter center on" v-if="index == selectIndex">
													<div>{{ item.today == 1 ? '今天' : '周' + item.wd }}</div>
													<div class="ml4">{{ item.md }}</div>
												</div>
												<div v-else class="this-week-item flex alcenter center" @click="changeDay(index)">
													<div class="cl-main">周{{ item.wd }}</div>
													<div class="ml4">{{ item.md }}</div>
												</div>
											</template>
										</div>

										<div class="next-week-button" @click="getDownWeek()">
											<div class="flex alcenter center">
												<div>下一周</div>
												<i class="iconfont iconnext ft12 cl-theme ml2" />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>


						<a-table :columns="columns" :data-source="mockData" :scroll="{ x: mockDataTechnician.length * 150 }"
							bordered>
							<div :slot="`bookDetail-${technician.technician_id}`" slot-scope="text, record,index"
								v-for="(technician, ii) in mockDataTechnician" :key="technician.technician_id">
								<template v-for="(book, ii) in record.bookProject">
									<div class="kanban-table-item" v-if="book.technician_id === technician.technician_id">
										<!-- 预约详情 -->
										<div class="ml10 pr15">
											<div>
												<div class="ft14 ftw500 " :style="{color:setting[book.status].memberColor}">{{book.member_name}} {{book.member_mobile}}</div>
												<div class="flex alcenter mt8">
													<div :style="{background: setting[book.status].mainColor}" class="kanban-table-content-member-appoint-item-time">{{book.start_time}}-{{book.end_time}}</div>
													<div :style="{color:setting[book.status].projectColor}" class="ml8 ft14 ftw400">{{book.project_name}}</div>
												</div>
											</div>
											<div>
												<a-dropdown placement="bottomRight">
													<span class="more-act">
														<i class="iconfont iconmore_gray"></i>
													</span>
													<a-menu slot="overlay">
														<a-menu-item>
															<a class="menu-act" href="javascript:;" @click="showDetailAct(book)">
																<i class="iconfont ft14 iconsee"></i>
																<span class="ml10">查看详情</span>
															</a>
														</a-menu-item>
														<a-menu-item v-if=" book.status==2">
															<a class="menu-act" href="javascript:;"  @click="arrivalAppointItemAct(book)">
																<i class="iconfont ft14 iconorder_operation_cancle"></i>
																<span class="ml10">确认到店</span>
															</a>
														</a-menu-item>
														<a-menu-item v-if="book.status==2">
															<a class="menu-act" href="javascript:;"  @click="shuangAppointItemAct(book)">
																<i class="iconfont ft14 iconorder_operation_cancle"></i>
																<span class="ml10">已爽约</span>
															</a>
														</a-menu-item>
														<a-menu-item v-if="book.status==1">
															<a class="menu-act" href="javascript:;"  @click="cancelAppointItemAct(book)">
																<i class="iconfont ft14 iconorder_operation_cancle"></i>
																<span class="ml10">取消预约</span>
															</a>
														</a-menu-item>
													</a-menu>
												</a-dropdown>
											</div>
										</div>

									</div>
								</template>
							</div>
						</a-table>


						<div class="flex center mt20">
							<a-pagination @change="pageChange" :total="pagination.total" v-model="pagination.current"
								:pageSize="pagination.pageSize" show-less-items />
						</div>

						<div v-if="showDetailVisible">
							<order-item-detail :visible="showDetailVisible" :order="order" @cancel="cancelShowDetail"
								@sureAppoint="sureAppoint" @cancelAppoint="cancelAppoint" @sureWriteOff="sureWriteOff"></order-item-detail>
						</div>
						<div v-if="cancelAppointVisible">
							<cancel-appoint-item :appointment_item_id="appointment_item_id" :visible="cancelAppointVisible"
								@cancel="cancelCancelAppoint" @ok="okCancelAppoint"></cancel-appoint-item>
						</div>
						<div v-if="addAppointmentVisible">
							<add-appointment :visible="addAppointmentVisible" @cancel="cancelAddAppointment"
								@ok="okAddAppointment"></add-appointment>
						</div>
					</div>
				</div>
			</div>
		</a-spin>

	</div>
</template>

<script>
import helper from '../../common/helper.js';
import orderItemDetail from './components/order/modal/itemDetail.vue';
import cancelAppointItem from './components/order/modal/detail/modal/cancelAppointItem.vue';
import addAppointment from './components/order/modal/addAppointment.vue';
export default {
	components: {
		orderItemDetail,
		cancelAppointItem,
		addAppointment,
	},
	data() {
		return {
			loading: false,
			showDetailVisible: false,
			cancelAppointVisible: false,
			addAppointmentVisible: false,
			appointment_item_id: 0,
			order: {},
			settings: [
				{ status: 1, status_means: '待支付', mainColor: '#4772FF', memberColor: '#000000', projectColor: '#656A75' },
				{ status: 2, status_means: '待到店', mainColor: '#FF7519', memberColor: '#000000', projectColor: '#656A75' },
				{ status: 3, status_means: '部分完成', mainColor: '#66ff66', memberColor: '#000000', projectColor: '#656A75' },
				{ status: 4, status_means: '已完成', mainColor: '#66ff66', memberColor: '#000000', projectColor: '#656A75' },
				{ status: 5, status_means: '部分取消', mainColor: '#A6AEC2', memberColor: '#000000', projectColor: '#656A75' },
				{ status: 6, status_means: '已取消', mainColor: '#A6AEC2', memberColor: '#000000', projectColor: '#656A75' },
				{ status: 7, status_means: '部分爽约', mainColor: '#cc0000', memberColor: '#000000', projectColor: '#656A75' },
				{ status: 8, status_means: '已爽约', mainColor: '#cc0000', memberColor: '#000000', projectColor: '#656A75' },
			],
			setting: [],
			week: 0,
			selectIndex: 0,
			today: null,
			days: [],
			pagination: {
				current: 1,
				pageSize: 5, //每页中显示10条数据
				total: 0,
			},
			search: {
				mendian_id: 0
			},
			datas: [],
			mendians: [],
			mockData: [
				// { date: '9点-10点', bookProject: [{ name: 'xxx服务1', technicianId: 1 }, { name: 'xxx服务4', technicianId: 1 }, { name: 'xxx服务6', technicianId: 1 }] },
				// { date: '10点-11点', bookProject: [{ name: 'xxx服务2', technicianId: 2 }] },
				// { date: '11点-12点', bookProject: [{ name: 'xxx服务3', technicianId: 3 }, { name: 'xxx服务5', technicianId: 1 }, { name: 'xxx服务7', technicianId: 1 }] },
			],
			mockDataTechnician: [
				// { name: '李大良AA', technicianId: 1 },
				// { name: '张三', technicianId: 2 },
				// { name: '张三', technicianId: 3 },
				// { name: '张三', technicianId: 4 },
				// { name: '张三', technicianId: 5 },
				// { name: '张三', technicianId: 6 },
				// { name: '张三', technicianId: 7 },
				// { name: '张三', technicianId: 8 },
				// { name: '张三', technicianId: 9 },
				// { name: '张三', technicianId: 10 },
				// { name: '张三', technicianId: 11 },
				// { name: '张三', technicianId: 12 },
			],
			columns: []
		}
	},
	created() {
		this.getMendians();

		this.setting[1] = { status: 1, status_means: '待支付', mainColor: '#4772FF', memberColor: '#000000', projectColor: '#656A75' };
		this.setting[2] = { status: 2, status_means: '待到店', mainColor: '#FF7519', memberColor: '#000000', projectColor: '#656A75' };
		this.setting[3] = { status: 3, status_means: '部分完成', mainColor: '#66ff66', memberColor: '#000000', projectColor: '#656A75' };
		this.setting[4] = { status: 4, status_means: '已完成', mainColor: '#66ff66', memberColor: '#000000', projectColor: '#656A75' };
		this.setting[5] = { status: 5, status_means: '部分取消', mainColor: '#A6AEC2', memberColor: '#000000', projectColor: '#656A75' };
		this.setting[6] = { status: 6, status_means: '已取消', mainColor: '#A6AEC2', memberColor: '#000000', projectColor: '#656A75' };
		this.setting[7] = { status: 7, status_means: '部分爽约', mainColor: '#cc0000', memberColor: '#000000', projectColor: '#656A75' };
		this.setting[8] = { status: 8, status_means: '已爽约', mainColor: '#cc0000', memberColor: '#000000', projectColor: '#656A75' };

		let days = helper.getWeekArr();
		this.days = days;
		this.today = helper.getTimeArr();//获取今天
		this.selectIndex = this.today.w;

		this.getLists();
	},

	computed: {
		getDays() {
			if (this.today == null) return [];
			let arr = new Array;
			for (var a in this.days) {
				arr.push({
					today: this.days[a].today,
					md: this.days[a].md,
					wd: this.days[a].wd,
					day: this.days[a].y + '-' + this.days[a].m + '-' + this.days[a].d,
				});
			}
			return arr;
		}
	},
	methods: {
		getMendians() {
			this.$http.api('admin/getAllMendian').then(res => {
				this.mendians = res.mendian;

				this.getTechnicianList();
			}).catch(res => {
				console.log(res);
			});
		},
		getTechnicianList() {
			this.$http.api('admin/getTechnicianList').then(res => {
				this.mockDataTechnician = res.list;
				console.log('this.mockDataTechnician',this.mockDataTechnician)

				this.columns = [
					{
						title: '时间',
						dataIndex: 'date',
						fixed: this.mockDataTechnician.length > 5 ? 'left' : false,
						width: 100
					},
					...this.mockDataTechnician.map(r => ({
						title: r.name,
						dataIndex: r.technician_id,
						scopedSlots: { customRender: `bookDetail-${r.technician_id}` },
						width: 200
					}))
				]
			}).catch(res => {
				console.log(res);
			});
		},
		getLists() {
			if (this.loading == true) return;
			this.loading = true;
			this.$http.api('admin/showAppointmentKanbanNew', {
				limit: this.pagination.pageSize,
				page: this.pagination.current,
				day: this.getDays[this.selectIndex].day,
				mendian_id: this.search.mendian_id,
			}).then(res => {
				//this.pagination.total = res.total;
				//this.datas = res.list;
				this.mockData = res.datas;
				console.log('this.mockData', this.mockData)
				this.loading = false;
			}).catch(res => {
				console.log(res);
				this.loading = false;
			})
		},

		// 确认预约（父单）
		sureAppointAct(index1, index2) {
			this.$confirm({
				title: '确认这个预约吗？',
				okText: "确定",
				okType: "danger",
				cancelText: "取消",
				onOk: () => {
					return new Promise((resolve, reject) => {
						this.$http.api('admin/sureAppointment', {
							appointment_id: this.datas[index1].orders[index2].appointment_id,
						}).then(res => {
							this.$message.success('确认成功');
							this.getLists();
						}).catch(res => {
							console.log(res);
						}).finally(() => {
							resolve();
						})
					})
				}
			})
		},

		// 确认到店（父单）
		arrivalAppointAct(index1, index2) {
			this.$confirm({
				title: '确认已经到店了吗？',
				okText: "确定",
				okType: "danger",
				cancelText: "取消",
				onOk: () => {
					return new Promise((resolve, reject) => {
						this.$http.api('admin/arrivalAppointment', {
							appointment_id: this.datas[index1].orders[index2].appointment_id,
						}).then(res => {
							this.$message.success('操作成功');
							this.getLists();
						}).catch(res => {
							console.log(res);
						}).finally(() => {
							resolve();
						})
					})
				}
			})
		},

		// 确认爽约（父单）
		shuangAppointAct(index1, index2) {
			this.$confirm({
				title: '确认已经爽约了吗？',
				okText: "确定",
				okType: "danger",
				cancelText: "取消",
				onOk: () => {
					return new Promise((resolve, reject) => {
						this.$http.api('admin/shuangAppointment', {
							appointment_id: this.datas[index1].orders[index2].appointment_id,
						}).then(res => {
							this.$message.success('操作成功');
							this.getLists();
						}).catch(res => {
							console.log(res);
						}).finally(() => {
							resolve();
						})
					})
				}
			})
		},

		// 查看订单详情
		showDetailAct(order) {
			console.log('order',order)
			this.order = order;
			this.showDetailVisible = true;
		},
		cancelShowDetail() {
			this.showDetailVisible = false;
		},
		sureAppoint() {
			this.showDetailVisible = false;
			this.getLists();
		},
		cancelAppoint() {
			this.showDetailVisible = false;
			this.getLists();
		},
		sureWriteOff() {
			this.showDetailVisible = false;
			this.getLists();
		},

		// 取消预约项
		cancelAppointItemAct(order) {
			this.appointment_item_id = order.appointment_item_id,
			this.cancelAppointVisible = true;
		},
		cancelCancelAppoint() {
			this.cancelAppointVisible = false;
		},
		okCancelAppoint() {
			this.cancelAppointVisible = false;
			this.getLists();
		},

		// 新增预约
		addAppointmentAct() {
			this.addAppointmentVisible = true;
		},
		cancelAddAppointment() {
			this.addAppointmentVisible = false;
		},
		okAddAppointment() {
			this.addAppointmentVisible = false;
			this.getLists();
		},

		getUpWeek() {
			this.week = this.week - 1;
			let days = helper.getWeekArr(this.week);
			this.days = days;
			this.getDatas();
		},
		getDownWeek() {
			this.week = this.week + 1;
			let days = helper.getWeekArr(this.week);
			this.days = days;
			this.selectIndex = 0;
			this.getDatas();
		},

		changeDay(index) {
			this.selectIndex = index;
			this.getDatas();
		},

		getDatas() {
			this.loading = false;
			this.pagination.current = 1;
			this.getLists();
		},

		pageChange(e) {
			this.pagination.current = parseInt(e);
			this.getLists();
		},
		changeMendian() {
			this.pagination.current = 1;
			this.getLists();
		},

		//确认到店项（子单）
		arrivalAppointItemAct(book){
			let item_id = book.appointment_item_id
			// 显示确认弹框
			this.$confirm({
				title: '确认到店',
				content: '确定要将此预约标记为已到店吗？',
				okText: '确认',
				cancelText: '取消',
				type: 'warning',
				onOk: () => {
					// 用户点击确认后执行的操作
					this.$http.api('admin/arrivalAppointmentItem',{
						appointment_item_id:item_id,
					}).then(res=>{
						this.$message.success('操作成功',1,()=>{
							
							// 重新获取订单数据
							this.getLists();
						});
						
					}).catch(res=>{
						console.log(res);
					})
				},
				onCancel: () => {
					// 用户点击取消，什么都不做
					console.log('用户取消操作');
				}
			});
		},

		// 已爽约（子单）
		shuangAppointItemAct(book){
			let item_id = book.appointment_item_id
			// 显示确认弹框
			this.$confirm({
				title: '确认已爽约',
				content: '确定要将此预约标记为已爽约吗？',
				okText: '确认',
				cancelText: '取消',
				type: 'warning',
				onOk: () => {
					// 用户点击确认后执行的操作
					this.$http.api('admin/shuangAppointmentItem',{
						appointment_item_id:item_id,
					}).then(res=>{
						this.$message.success('操作成功',1,()=>{
							
							// 重新获取订单数据
							this.getLists();
						});
						
					}).catch(res=>{
						console.log(res);
					})
				},
				onCancel: () => {
					// 用户点击取消，什么都不做
					console.log('用户取消操作');
				}
			});
		},
	}
}
</script>

<style scoped>
.setting-item {
	width: 14px;
	height: 14px;
}

.kanban-table-header {
	width: 100%;
	height: 60px;
	background: #FFFFFF;
}

.kanban-table-header-left {
	width: 170px;
	height: 60px;
}

.kanban-table-header-right {
	width: calc(100% - 170px);
	height: 60px;
	border: 1px solid #EBEDF5;
	border-left: none;
	padding: 0px 20px;
	line-height: 1;
}

.last-week-button {
	width: 90px;
	height: 40px;
	background: #FFFFFF;
	border-radius: 4px;
	border: 1px solid #EBEDF5;
	font-size: 14px;
	font-weight: 500;
	color: #656A75;
	text-align: center;
	line-height: 38px;
	cursor: pointer;
}

.this-week-item {
	height: 40px;
	font-size: 12px;
	font-weight: 500;
	color: #A6AEC2;
	width: 10%;
	margin-left: 3%;
	margin-left: 3%;
	cursor: pointer;
}

.this-week-item.on {
	height: 40px;
	background: #4772FF;
	border-radius: 4px;
	color: #FFFFFF;
}

.next-week-button {
	width: 90px;
	height: 40px;
	background: #FFFFFF;
	border-radius: 4px;
	border: 1px solid #4772FF;
	font-size: 14px;
	font-weight: 500;
	color: #4772FF;
	text-align: center;
	line-height: 38px;
	cursor: pointer;
}

.kanban-table-item {
	border-bottom: 1px solid #e8e8e8;
	padding: 5px 0;
}

.kanban-table-item:last-child {
	border: none;
}
</style>
